/* tslint:disable */
/* eslint-disable */
export enum EmploymentStatus {
  SelfEmployed = 'SelfEmployed',
  Employed = 'Employed',
  Unemployed = 'Unemployed'
}
